import { takeEvery, all, select, put, call } from 'redux-saga/effects';
import { GET_MY } from '../../containers/App/constants';
import { REQUEST_EMAIL_HISTORY, FILTER_DEFAULT_LIMIT, REQUEST_EMAIL_HISTORY_FILTER } from './constants';
import { selectEmailHistoryFilter } from './selector';

function* requestEmailHistoryFilter() {
  const filter = yield select(selectEmailHistoryFilter());
  let offset = filter.offset || 0;
  let limit = filter.limit || FILTER_DEFAULT_LIMIT;
  let text = filter.searchString || null;

  let path = `/admin/email/history/getAll?offset=${offset}&limit=${limit}&sortType=createdAt`;

  const searchParams = {
    offset,
    limit,
    text: text ?? undefined,
    filters: [],
  };

  yield put({
    type: GET_MY,
    id: REQUEST_EMAIL_HISTORY,
    work: REQUEST_EMAIL_HISTORY,
    path,
    get: searchParams,
  });
}

export function* emailHistorySaga() {
  yield all([takeEvery(REQUEST_EMAIL_HISTORY_FILTER, requestEmailHistoryFilter)]);
}
